<template>
    <div
        class="o-promoPreview"
        :class="[{ selectedPromo: selected }, featuredClass]"
        :promo_id="promotion.id"
        :key="`promo_id-${promotion.id}`"
    >
        <div
            @click="
                setScroll()
                saveExpandedGroupToStorage()
            "
        >
            <component
                :is="
                    this.previewType === 'group-accept' ||
                        this.previewType === 'labels'
                        ? 'div'
                        : 'router-link'
                "
                :to="goToRoute"
                class="o-promoPreview__link"
            >
                <div class="d-flex o-promoPreview__topRow">
                    <div class="o-promoPreview__imageWrapper">
                        <img :src="promoImg" class="o-promoPreview__image" />
                    </div>

                    <promotion-preview-small-details
                        class="o-promoPreview__smallDetailsWrapper --desktop"
                        :preview-type="previewType"
                        :acceptance="acceptance"
                        :group-id="groupId"
                        :show-more="promotion.showMore"
                        :is-active-promos-tab="isActivePromosTab"
                        :promotion="promotion"
                        @showMore="showMoreDetails"
                    />
                    <div
                        v-if="
                            previewType !== 'group-accept' &&
                                previewType !== 'labels'
                        "
                        class="o-promoPreview__chevronWrapper btn btn-custom-gray d-none d-md-flex"
                        :class="{ '--expanded': promotion.showMore }"
                        @click.prevent.stop="showMoreDetails"
                    >
                        <a-icon
                            :icon="promotion.showMore ? 'ArrowUp' : 'ArrowDown'"
                            class="o-promoPreview__chevron"
                        />
                    </div>
                </div>
            </component>
        </div>
        <promotion-preview-small-details
            class="o-promoPreview__smallDetailsWrapper --mobile"
            :preview-type="previewType"
            :show-more="promotion.showMore"
            :group-id="groupId"
            :acceptance="acceptance"
            :is-active-promos-tab="isActivePromosTab"
            :promotion="promotion"
            @showMore="showMoreDetails"
        />

        <div v-if="promotion.showMore" class="o-promoPreview__details">
            <promotion-preview-details
                :group-id="groupId"
                :preview-type="previewType"
                :promotion="promotion || {}"
            >
                <template #promotionShops>
                    <slot name="promotionShops" />
                </template>
            </promotion-preview-details>
        </div>
    </div>
</template>

<script>
import PromotionPreviewSmallDetails from '@/components/promotions/promotionsPreview/PromotionPreviewSmallDetails'
import PromotionPreviewHeart from '@/components/promotions/promotionsPreview/PromotionPreviewHeart'
import PromotionPreviewDetails from '@/components/promotions/promotionsPreview/PromotionPreviewDetails'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    name: 'PromotionPreview',
    components: {
        PromotionPreviewSmallDetails,
        PromotionPreviewHeart,
        PromotionPreviewDetails
    },
    props: {
        previewType: {
            validator: function(value) {
                // The value must match one of these strings
                return [
                    'labels',
                    'promo-labels',
                    'promo-yours',
                    'promo-finished',
                    'promo-later',
                    'promo-list',
                    'group-accept'
                ].includes(value)
            }
        },
        groupId: { type: Number, required: false, default: null },
        acceptance: { type: String, default: '' },
        promotion: { type: Object, required: true },
        selectedGroups: { type: Boolean, default: false }
    },
    computed: {
        isPromotionPreviewClickable() {
            return (
                this.previewType !== 'group-accept' &&
                this.previewType !== 'labels'
            )
        },
        selected() {
            return this.$store.getters.getSelectedPromotionBoolean(
                this.promotion.id
            )
        },
        featuredClass() {
            if (this.$route === 'promo-finished') {
                return ''
            }

            if (this.promotion.featured) {
                return 'o-promoPreview--featured'
            } else if (this.promotion.loyalty) {
                return 'o-promoPreview--loyalty'
            }

            return ''
        },
        isMerchantActive() {
            const { subscriptions } = this.promotion

            return (
                subscriptions &&
                subscriptions.some(e => e.company_merchant_status === 'active')
            )
        },
        isPromoActive() {
            return this.promotion.state === 'active'
        },
        goToRoute() {
            if (
                this.isPromoActive ||
                this.isMerchantActive ||
                this.previewType === 'promo-labels'
            ) {
                return `/promo-details/${this.promotion.id}`
            }

            return `/service/${this.promotion.company.service_id}`
        },

        promoImg() {
            if (this.promotion.type === PROMO_TYPES.ADVERTISEMENT) {
                return require('@/assets/img/promo-adv.png')
            } else {
                return (
                    this.promotion.logo?.urls.small ||
                    require('@/assets/logo-ep.svg')
                )
            }
        }
    },
    watch: {
        $route: {
            handler: function(route) {
                if (route.name === 'promo-yours') {
                    this.isActivePromosTab = true
                } else {
                    this.isActivePromosTab = false
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        saveExpandedGroupToStorage() {
            const promoListPath = this.$router.resolve({
                name: 'promo-list'
            }).href
            const labelListPath = this.$router.resolve({
                name: 'labels'
            }).href
            if (
                this.$router.currentRoute.path.includes(promoListPath) ||
                this.$router.currentRoute.path.includes(labelListPath)
            ) {
                return
            }
            if (!this.isMerchantActive && this.previewType !== 'promo-labels') {
                return
            }
            const groups =
                this.previewType !== 'promo-labels'
                    ? this.$store.getters.getPromoGroups
                    : this.$store.getters.getLabelGroups
            const group = groups.find(el => el.id === this.groupId)
            const groupObj = {
                promos: group.promos,
                pagination: group.pagination,
                groupId: group.id,
                promoId: this.promotion.id,
                saveTime: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
                promoListRoute: this.currentRoute
            }

            this.$store.$storage.setItem('expandedGroup', groupObj)
        },
        setScroll() {
            this.$store.dispatch('setScrollY', window.scrollY)
        },
        async showMoreDetails() {
            this.$set(this.promotion, 'showMore', !this.promotion.showMore)

            // if promo products are already fetched, do not fetch again
            if (
                +this.promotion.productsPagination?.totalRecords > 0 ||
                !this.promotion.showMore
            ) {
                return
            }

            const productSet = this.promotion.product_sets?.[0]

            const payload = {
                promoId: this.promotion.id,
                groupId: this.groupId,
                main: true,
                fromSelectedGroups: this.selectedGroups,
                productSetId: productSet?.id ?? null
            }

            if (this.previewType === 'labels') {
                this.$store.dispatch('loadLabelsProductsAndResources', {
                    ...payload,
                    promo: this.promotion,
                    selectedLabels: true
                })
            } else if (this.previewType === 'group-accept') {
                const res = await this.$store.dispatch(
                    'fetchProductsByPromoGroupPromo',
                    payload
                )

                if (this.promotion.all_eans_present) {
                    return
                }

                this.$store.dispatch('setMerchantEansInSelectedPromoGroup', {
                    products: res,
                    promotion: this.promotion,
                    params: {
                        per: 99999
                    },
                    config: {
                        noCancel: true
                    }
                })
            } else if (this.previewType === 'promo-labels') {
                if (this.promotion.products?.length) {
                    return
                }
                this.$store.dispatch('loadLabelProducts', {
                    params: {
                        promo_id: this.promotion.id,
                        main: true,
                        per: 100
                    },
                    promo: this.promotion
                })
            } else {
                this.$store.dispatch('fetchProductsByPromoGroupPromo', payload)
            }
        }
    },
    created() {
        this.currentRoute = this.$route.name
    },
    data() {
        return {
            currentRoute: null,
            isActivePromosTab: false
        }
    }
}
</script>
